/* eslint-disable import/prefer-default-export */ // This is needed , default export does not work with svelte
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import axios from 'axios';
import { get } from 'svelte/store';
import type { User } from 'firebase/auth';
import { browser } from '$app/environment';
import { goto } from '$app/navigation';
import { SERVER_URL } from '$constants/api';
import { firebaseAuthStore } from '../../stores/firebase.store';

import { initilizeFirebase } from '../firebase.util';

import { isLoggedIn } from '../../stores/auth.store';
import { me } from '../../stores/user.store';

interface FirebaseAuthStore {
  loading: boolean;
  user: User;
}

let retryCount = 0;
const maxRetries = 20;
const getloaded = (): Promise<FirebaseAuthStore> => new Promise((resolve, reject) => {
  const checkLoading = () => {
    if (retryCount > maxRetries) {
      reject(new Error('Max retries exceeded'));
      return;
    }

    if (get(firebaseAuthStore).loading) {
      setTimeout(() => {
        retryCount += 1;
        console.log(get(firebaseAuthStore))
        checkLoading();
      }, 2000);
    } else {
      resolve(get(firebaseAuthStore));
    }
  };

  checkLoading();
});


const api = axios.create({ baseURL: SERVER_URL });
let tryFirebase = false;

api.interceptors.request.use(
  async config => {
    if (browser) {
      const accessToken = localStorage.getItem('accessToken');
      const firebaseToken = await get(firebaseAuthStore)?.user?.getIdToken();
      // console.log('isloggedin', get(isLoggedIn), firebaseToken, accessToken, get(me));

      // if we dont have a valid firebase token and we are not logged in, we need to initialize firebase
      if (!accessToken && !firebaseToken && !get(isLoggedIn) && !get(me) && !tryFirebase) {
        await initilizeFirebase();
        tryFirebase = true;
      }
      await getloaded();

      if (!accessToken) {
        if (!firebaseToken && get(isLoggedIn)) {
          await initilizeFirebase();
        }
      }

      // i should be able to pass $me or the contents of the user store into a load function

      if (firebaseToken) {
        config.headers['firebase-token'] = firebaseToken;
      } else if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
    }

    return config;
  },
  err => Promise.reject(err)
);

api.interceptors.response.use(
  res => res,
  async err => {
    if (!browser) return;

    const originalConfig = err.config;
    const refreshToken = localStorage.getItem('refreshToken');
    const firebaseAuthStoreValue = await getloaded();

    // console.log('firebaseAuthStoreValue', firebaseAuthStoreValue);

    // No need to try to refresh for login and signup
    if (
      !String(originalConfig.url).includes('/user/login') &&
      !String(originalConfig.url).includes('/user/signup') &&
      !String(originalConfig.url).includes('/user/firebaseSignUp') &&
      !firebaseAuthStoreValue // if we dont already have a valid auth user 
    ) {
      // try to refresh the token if it was expired
      if (
        err.response.status === 403 &&
        !originalConfig.headers['x-refresh'] &&
        !originalConfig.headers['firebase-token'] &&
        refreshToken
      ) {
        try {
          return await api
            .get('/user/me', {
              headers: {
                'x-refresh': `${refreshToken}`
              }
            })
            .then(resp => {
              const newAccessToken: string = resp.headers['x-access-token'];

              if (newAccessToken) {
                localStorage.setItem('accessToken', newAccessToken);

                const newConfig = originalConfig;
                newConfig.headers.Authorization = `Bearer ${newAccessToken}`;

                return api(newConfig);
              }
              goto('/login');

              return api(originalConfig);
            })
            .catch(async _err => {
              const newAccessToken: string = _err.response.headers['x-access-token'];

              if (newAccessToken) {
                localStorage.setItem('accessToken', newAccessToken);

                const newConfig = originalConfig;
                newConfig.headers.Authorization = `Bearer ${newAccessToken}`;

                return api(newConfig);
              }
              goto('/login');

            });
        } catch (_err) {
          return Promise.reject(_err);
        }
      } else {
        return Promise.reject(err);
      }
    } else {
      return Promise.reject(err);
    }
  }
);

export { api };
